module.exports = __webpack_public_path__ + "media/images/icons/icon-2de9fc5093d8773a0c9d7e0b29dc9a20.svg";